import React from "react"
import { Helmet } from "react-helmet"
import { CloudinaryImage } from "@cloudinary/url-gen"
import { AdvancedImage } from "@cloudinary/react"
import { scale } from "@cloudinary/url-gen/actions/resize"

import Button from "@mui/material/Button"

import {
  phoneNumber,
  officeHours,
  SUPPORT_EMAIL,
  phoneHours,
} from "../../config"

const coastlineAcademyImg = new CloudinaryImage(
  "accent-images/undraw_contact_us_15o2_lighter_o5gy7z",
  { cloudName: "coastline-academy" },
)
  .resize(scale(640))
  .quality(80)
  .format("auto")

const Contact = () => (
  <div className="container" style={{ maxWidth: 650, margin: "0 auto" }}>
    <Helmet>
      <title>Contact Coastline Academy</title>
    </Helmet>
    <h1>Contact Coastline Academy</h1>
    <p>
      Need a driving lesson? Want to make changes to your scheduled lessons?
      Have questions about the process? We&apos;re here to help!
    </p>
    <h3>Phone Support</h3>
    <p>Phone support is available {phoneHours}.</p>
    <h3>Text (SMS), Email, Chat</h3>
    <p>
      Text us at <a href={`sms:${phoneNumber}`}>{phoneNumber}</a>, available{" "}
      {officeHours}.
    </p>
    <p>
      If you reach out after hours, we&apos;ll get back to you as soon as we
      can.
    </p>
    <div style={{ marginTop: 40, marginBottom: 40 }}>
      <a href={`tel:${phoneNumber}`}>
        <Button
          variant="contained"
          color="primary"
          data-cy="button-phone"
          style={{ marginRight: 20 }}
        >
          Call {phoneNumber}
        </Button>
      </a>
      <a href={`mailto:${SUPPORT_EMAIL}`}>
        <Button variant="contained" color="primary" data-cy="button-email">
          Email
        </Button>
      </a>
    </div>

    <AdvancedImage cldImg={coastlineAcademyImg} />
  </div>
)

export default Contact
